module.exports = __webpack_public_path__ + "img/wizard-loader-2.cc3400d4.png";